import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse,
  HttpUserEvent, HttpErrorResponse, HttpEvent
} from "@angular/common/http";
import { Injectable } from "@angular/core";


import { ToastService } from "../services/toast.service";
import { Observable, throwError } from 'rxjs';
import { map, catchError,tap } from 'rxjs/operators';

@Injectable()
export class ResponseMessagesInterceptor implements HttpInterceptor {
  constructor(private toastService: ToastService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const clone = request.clone();
    var handleObj  = next.handle(clone);
    if(handleObj)
      return handleObj.pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            let responseMessages = (event.body) ? event.body.responseMessages || [] : [];
            responseMessages.forEach( message => {
              if (message.responseMessageType === 3) this.toastService.showError(message.value)
              else this.toastService.showSuccess(message.value);
            })
          }
        }),catchError((error: HttpErrorResponse) =>{
          console.log("Error received", error);
          return throwError(error);
        }) );
  }
}